<template>
  <section id="not-found-error">
    <v-container class="not-found-container">
      <img src="/cdn/images/mascot.png" class="error-image" />
      <v-col cols="12" class="text-left">
        <h3 class="error-code">{{ $t("views.error.error") }} 404</h3>
        <h1 class="header">
          {{ $t("views.error.404.header") }}
        </h1>
        <p class="error-text">
          {{ $t("views.error.404.text") }}
        </p>
        <v-btn color="primary" to="/">
          {{ $t("views.results.goTo") }}
        </v-btn>
      </v-col>
    </v-container>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "FileNotFound",
  data() {
    return {};
  },
  beforeMount() {
    this.initNavigation();
  },
  methods: {
    ...mapMutations("app", [
      "set_topnavigation_settings",
      "set_bottomnavigation_settings",
    ]),
    initNavigation() {
      this.set_topnavigation_settings({
        visible: false,
      });
      this.set_bottomnavigation_settings({
        visible: false,
      });
    },
  },
};
</script>

<style lang="scss">
//for the formulas:
// calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width])));
.error-image {
  margin-top: 80px;
  width: calc(200px + (300 - 200) * ((100vw - 300px) / (1600 - 300)));
  height: auto;
}
.error-code {
  font-size: calc(20px + (30 - 20) * ((100vw - 300px) / (1600 - 300)));
  line-height: calc(1em + (1.5 - 1) * ((100vw - 300px) / (1600 - 300)));
  font-weight: 400;
  opacity: 0.6;
}
.header {
  font-size: calc(40px + (90 - 40) * ((100vw - 300px) / (1600 - 300)));
  line-height: calc(0.7em + (1.5 - 0.7) * ((100vw - 300px) / (1600 - 300)));
  margin-top: 10px;
  font-weight: 410;
}
.error-text {
  font-size: calc(15px + (25 - 15) * ((100vw - 300px) / (1600 - 300)));
  margin-top: 30px;
  font-weight: 400;
  opacity: 0.5;
}
</style>
